import Avatar from '../layout/Avatar'
import AiAvatarIcon from '../../../assets/icons/stars.svg?react'

const AiAvatar = () => {
  return (
    <Avatar icon={<AiAvatarIcon stroke='white' className='w-7 h-7' />} size='xl' />
  )
}

export default AiAvatar
